import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const VehicleClassesService = {
    list: async () => axios.post(API_URL + "/vehicleClasses/list").then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/vehicleClasses/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/vehicleClasses`, data).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, data) => axios.post(API_URL + `/vehicleClasses/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/vehicleClasses/${id}`).then(({data}) => data).catch((err) => { throw err }),
    hasAssociated: async (id) => axios.get(`${API_URL}/vehicleClasses/${id}/has-associated`).then(({data}) => data).catch((err) => {throw err}),
    getAllToSelect: async () => axios.get(API_URL + `/vehicleClasses/options/all`).then(({data}) => data.data).catch((err) => { throw err }),
}

export default VehicleClassesService;
